exports.set_menu = (function(){
    'use strict';

    // スマホ版のリストメニュー
    $('.js-menu-bar-list').append(
        '<div class="widget widget_post-list widget_popular">' +
        $('.widget_popular').html() + '</div>' );

    // 複製するとタブ設定が重複してしまうので、差し換える
    $('.js-menu-bar-list .widget_popular .widget__tab').data('ccltab-content', '.menu-bar__content_list .js-ccltab-content_ranking');

    if( $('.widget_recent').length >= 1 ){
        $('.js-menu-bar-list').append(
            '<div class="widget widget_post-list widget_recent">' +
            $('.widget_recent').html() + '</div>' );
    }

    $('.js-menu-bar-list').append(
        '<div class="widget widget_post-list widget_recommend">' +
        $('.widget_recommend').html() + '</div>' );

    // メニューの開閉
    $('.js-menu-menu-open').click(function(event){
        if( $(this).hasClass('active') ){
            menubar_switch( 'menu', false );
        }else{
            menubar_switch( 'menu', true );
        }
        // return false;
        event.preventDefault();
    });

    // リストの開閉
    $('.js-menu-list-open').click(function(event){
        if( $(this).hasClass('active') ){
            menubar_switch( 'list', false );
        }else{
            menubar_switch( 'list', true );
        }
        // return false;
        event.preventDefault();
    });

    // メニューの切り替え設定がややこしいからまとめた
    function menubar_switch( target, isOpen ){
        var $target_btn, $target_bar, $untarget_btn, $untarget_bar;

        if( target == 'menu' ){
            $target_btn = $('.js-menu-menu-open');
            $target_bar = $('.js-menu-bar-menu');
            $untarget_btn = $('.js-menu-list-open');
            $untarget_bar = $('.js-menu-bar-list');
        }else{
            $target_btn = $('.js-menu-list-open');
            $target_bar = $('.js-menu-bar-list');
            $untarget_btn = $('.js-menu-menu-open');
            $untarget_bar = $('.js-menu-bar-menu');
        }

        if( isOpen ){
            $target_btn.addClass('active');
            $target_bar.removeClass('menu-bar__content_init');
            $target_bar.removeClass('menu-bar__content_close');
            $target_bar.addClass('menu-bar__content_open');
            $untarget_btn.removeClass('active');

            if( !$untarget_bar.hasClass('menu-bar__content_init') ){
                $untarget_bar.addClass('menu-bar__content_close');
                $untarget_bar.removeClass('menu-bar__content_open');
            }

        }else{
            $target_btn.removeClass('active');
            $target_bar.addClass('menu-bar__content_close');
            $target_bar.removeClass('menu-bar__content_open');
        }
    }

})();



/*****************
 ** WEBPACK FOOTER
 ** ./js/menu.js
 ** module id = 3
 ** module chunks = 0
 **/